export default __webpack_public_path__ + "static/media/LOGO-RocketDAO.c4445791.svg";